













import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Rectangle, Point, Vector, Size, LineStyle, LineKinds } from "../../../domain/drawing";
import { SvgPathFactory } from "../utilities";

@Component
export default class LineDrawer extends Mixins() {
  @Prop()
  vector: Vector;

  @Prop()
  lineStyle: LineStyle;

  @Prop({ default: 4 })
  minStrokeWidth: number;

  @Emit()
  pointerdown(event: PointerEvent): void {}

  get rectangle(): Rectangle {
    // chromeでSizeが0の場合、線が描画されないため最低限のSizeを確保する
    const rect = Rectangle.from(this.vector);
    const addWidth = rect.width < 1 ? 1 : 0;
    const addHeight = rect.height < 1 ? 1 : 0;
    return rect.add(new Rectangle(new Point(), new Size(addWidth, addHeight)));
  }

  get rectangleStyles() {
    return {
      position: "absolute",
      top: this.rectangle.x + "px",
      left: this.rectangle.y + "px",
      width: this.rectangle.width + "px",
      height: this.rectangle.height + "px",
    };
  }

  get lineStyleProperties() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: this.lineStyle.color.value,
      strokeWidth: this.lineStyle.width,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get draggableLineStyleProperties() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: "transparent",  // transparentで描画する事で、pointerEvents対象とする.)
      strokeWidth: this.draggableStrokeWidth,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get draggableStrokeWidth(): number {
    return Math.max(this.lineStyle.width, 4);
  }

  get drawerStyleProperties() {
    return {
      position: "absolute",
      top: this.rectangle.x + "px",
      left: this.rectangle.y + "px",
      width: this.rectangle.width + "px",
      height: this.rectangle.height + "px",
    };
  }

  get isDouble(): boolean {
    return this.lineStyle.kind === LineKinds.Double;
  }

  get from(): Point {
    return this.vector.from;
  }

  get to(): Point {
    return this.vector.to;
  }

  get path(): string {
    return SvgPathFactory.createPolyline(this.from, this.to);
  }

  get doubleFirstPath(): string {
    return this.createParallelPath(Math.PI / 2, 3);
  }

  get doubleSecondPath(): string {
    return this.createParallelPath(Math.PI / 2 * -1, 3);
  }

  createParallelPath(createAngle: number, gap: number): string {
    if (this.angle === null)  { return this.path; }
    const angle = this.angle + createAngle;
    const difference = new Point(
      gap * Math.cos(angle),
      gap * Math.sin(angle)
    );
    return SvgPathFactory.createPolyline(this.from.add(difference), this.to.add(difference));
  }

  get angle(): number {
    const x = this.from.x - this.to.x;
    const y = this.from.y - this.to.y;
    // 分岐させなくてもMathで対応している？検証未了
    if (x === 0) {
      if (y > 0) { return Math.PI / 2; }
      if (y < 0) { return Math.PI / 2 * -1; }
      return null;
    }
    return Math.atan(y / x);
  }
}
